import { formatData, checkErrorData } from "./utils";

export function fetchSubProducts(){
    console.log("FIRED ACTION FETCH SUB_PRODUCTS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_SUB_PRODUCTS_START",
            payload: ""
        })
        
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"sub/products",
                }),
                credentials: 'same-origin',
            }); 
            
            const prodsList = await response.json()
            console.log(prodsList)

            if(!prodsList.error){ // no errors
                
                dispatch(getSubProducts(formatData(prodsList.reverse()) ))
                dispatch({ type: "FETCH_SUB_PRODUCTS_FULFILLED", payload:"" })
                console.log(" subproducts fetched")
                
                // dispatch(fetchStocks())
            
            } else {
                dispatch({
                    type: "FETCH_SUB_PRODUCTS_ERROR",
                    payload: prodsList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_SUB_PRODUCTS_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchSubProductsFromMainProduct(prodID){
    console.log("FIRED ACTION FETCH SUB_PRODUCTS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_SUB_PRODUCTS_START",
            payload: ""
        })
        
        try {
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"sub/products/list",
                    id: prodID
                }),
                credentials: 'same-origin',
            }); 
            
            const prodsList = await response.json()
            console.log(prodsList)

            if(!prodsList.error){ // no errors
                
                // dispatch(getSubProducts(formatData(prodsList.reverse()) ))
                // dispatch({ type: "FETCH_SUB_PRODUCTS_FULFILLED", payload:"" })
                // console.log(" subproducts fetched")
                
                // dispatch(fetchStocks())
                return prodsList
            } else {
                dispatch({
                    type: "FETCH_SUB_PRODUCTS_ERROR",
                    payload: prodsList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_SUB_PRODUCTS_ERROR",
                payload: err
                
            })
        }
    }
}

export function createSubProduct(newProd){
    // console.log("FIRED ACTION CREATE SUB_PRODUCT", newSubProduct)
    return async function(dispatch){
        dispatch({
            type: "CREATE_SUB_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"sub/products",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSubProduct = await response.json()
            console.log(createdSubProduct)// createdSubProduct returns new object created

            if(createdSubProduct.id){ // no errors, return new Object
                dispatch({
                    type: "NEW_SUB_PRODUCT",
                    payload: createdSubProduct
                    
                })
                dispatch({ type: "CREATE_SUB_PRODUCT_FULFILLED", payload:"" })
                console.log("SubProduct created")
            } else {
                dispatch({
                    type: "CREATE_SUB_PRODUCT_ERROR",
                    payload: createdSubProduct.error.message
                })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT SUB_PRODUCT ", err);
            dispatch({ type: "CREATE_SUB_PRODUCT_ERROR", payload: err })
        }
    }
}

export function updateSubProduct(data) {
    return async function(dispatch){
        try {
            dispatch({ type: "UPDATE_SUB_PRODUCT_START", payload: "" })

            console.log("update SubProduct START")
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"sub/products/update",
                    data: data
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedSubProduct = await response.json()
            
            console.log({updatedSubProduct});

            if(checkErrorData(updatedSubProduct, "UPDATE_SUB_PRODUCT_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_SUB_PRODUCT",
                    payload: data
                })
                dispatch({ type: "UPDATE_SUB_PRODUCT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update subproduct ", err);
            dispatch({
                type: "UPDATE_SUB_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}
export function getSubProducts(subproducts){
    // console.log("FIRED ACTION GET SUB_PRODUCT", subproducts)
    return {
        type: "GET_PRODS",
        payload: subproducts
    }
}

export function addPhotosSubProduct(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_PHOTOS_SUB_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"subproducts/add/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedSubProduct = await response.json()
            console.log(updatedSubProduct)// updatedSubProduct returns new object created

            if(updatedSubProduct.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_SUB_PRODUCT",
                    payload: updatedSubProduct
                    
                })
                dispatch({ type: "ADD_PHOTOS_SUB_PRODUCT_FULFILLED", payload:"" })
                console.log("SubProduct updated")

            } else {
                dispatch({
                    type: "ADD_PHOTOS_SUB_PRODUCT_ERROR",
                    payload: updatedSubProduct.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files SUB_PRODUCT ", err);
            dispatch({
                type: "ADD_PHOTOS_SUB_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}
export function updatePhotosSubProduct(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_PHOTOS_SUB_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"sub/products/update/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedSubProduct = await response.json()
            console.log(updatedSubProduct)// updatedSubProduct returns new object created

            if(updatedSubProduct.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_SUB_PRODUCT",
                    payload: updatedSubProduct
                    
                })
                dispatch({ type: "ADD_PHOTOS_SUB_PRODUCT_FULFILLED", payload:"" })
                console.log("SubProduct updated")

            } else {
                dispatch({
                    type: "ADD_PHOTOS_SUB_PRODUCT_ERROR",
                    payload: updatedSubProduct.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files SUB_PRODUCT ", err);
            dispatch({
                type: "ADD_PHOTOS_SUB_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}

export function createBin(newProd){
    // console.log("FIRED ACTION CREATE BIN", newBin)
    return async function(dispatch){
        dispatch({
            type: "CREATE_BIN_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"bins",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            const createdBin = await response.json()
            console.log(createdBin)// createdBin returns new object created

            if(createdBin.id){ // no errors, return new Object
                dispatch({
                    type: "NEW_BIN",
                    payload: createdBin
                    
                })
                dispatch({ type: "CREATE_BIN_FULFILLED", payload:"" })
                console.log("Bin created")
                return "OK"
            } else {
                dispatch({
                    type: "CREATE_BIN_ERROR",
                    payload: createdBin.error.message
                })
                throw new Error(createdBin.error.message)
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT BIN ", err);
            dispatch({ type: "CREATE_BIN_ERROR", payload: err })
            throw err
        }
    }
}
export function updateBin(data) {
    return async function(dispatch){
        try {
            dispatch({ type: "UPDATE_BIN_START", payload: "" })

            console.log("update Bin START")
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:`bins/update/${data.id}`,
                    data: data
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedBin = await response.json()
            
            console.log({updatedBin});

            if(checkErrorData(updatedBin, "UPDATE_BIN_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_BIN",
                    payload: data
                })
                dispatch({ type: "UPDATE_BIN_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update subproduct ", err);
            dispatch({
                type: "UPDATE_BIN_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchBinList(prodID){
    console.log("FIRED ACTION FETCH BINS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_BINS_START",
            payload: ""
        })
        
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"bins",
                }),
                credentials: 'same-origin',
            }); 
            
            const binsList = await response.json()
            console.log(binsList)

            if(!binsList.error){ // no errors
                
                // dispatch(getSubProducts(formatData(binsList.reverse()) ))
                // dispatch({ type: "FETCH_BINS_FULFILLED", payload:"" })
                // console.log(" bins fetched")
                
                // dispatch(fetchStocks())
                return binsList
            } else {
                dispatch({
                    type: "FETCH_BINS_ERROR",
                    payload: binsList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_BINS_ERROR",
                payload: err
                
            })
        }
    }
}